import { API_CACHE_KEYS } from "api/cacheKeys";
import { useCustomQuery } from "api/useCustomQuery";
import { AccountBillingInfo } from "components/account/ServicePlan/servicePlanUtils";
import { JANZU_URL } from "config/config";
import { UserLimits } from "types/tiers";

import { BaseQueryOptions } from "../types";


// Hook for fetching user banner limits
export const useAccountLimits = (
  options: BaseQueryOptions<UserLimits> = {}
) => useCustomQuery<UserLimits>(
  API_CACHE_KEYS.account.limits(),
  `${JANZU_URL}reef-api/account/banners`,
  { ...options }
);

// Hook for fetching user limits info stats
export const useAccountInfo = (
  options: BaseQueryOptions<AccountBillingInfo> = {}
) => useCustomQuery<AccountBillingInfo>(
  API_CACHE_KEYS.account.billingInfo(),
  `${JANZU_URL}reef-api/account/info`,
  { retry: 2, ...options }
);

// Combined hook that provides both get and update operations
export const useAccount = () => {
  const getAccountLimits = useAccountLimits();
  const getAccountInfo = useAccountInfo();

  return {
    // Get account limits for banners
    accountLimits: getAccountLimits.data,
    getAccountLimits: getAccountLimits.refetch,
    isLoadingAccountLimits: getAccountLimits.isFetching,
    accountLimitsError: getAccountLimits.error,

    // Get account limit info
    accountInfo: getAccountInfo.data,
    getAccountInfo: getAccountInfo.refetch,
    isLoadingAccountInfo: getAccountInfo.isFetching,
    accountInfoError: getAccountInfo.error,
  };
}; 